import React__default, { createContext, useState, useMemo, useId, useContext } from "react";
import { useEvent as o } from "../../hooks/use-event.js";
import { useIsoMorphicEffect as n } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as y } from "../../hooks/use-sync-refs.js";
import { useDisabled as a$1 } from "../../internal/disabled.js";
import { forwardRefWithAs as W, render as H } from "../../utils/render.js";
let a = createContext(null);
a.displayName = "DescriptionContext";
function f() {
  let r = useContext(a);
  if (r === null) {
    let e = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(e, f), e;
  }
  return r;
}
function G() {
  var r, e;
  return (e = (r = useContext(a)) == null ? void 0 : r.value) != null ? e : void 0;
}
function U() {
  let [r, e] = useState([]);
  return [r.length > 0 ? r.join(" ") : void 0, useMemo(() => function(t) {
    let i = o((n2) => (e((s) => [...s, n2]), () => e((s) => {
      let o2 = s.slice(), p = o2.indexOf(n2);
      return p !== -1 && o2.splice(p, 1), o2;
    }))), l = useMemo(() => ({ register: i, slot: t.slot, name: t.name, props: t.props, value: t.value }), [i, t.slot, t.name, t.props, t.value]);
    return React__default.createElement(a.Provider, { value: l }, t.children);
  }, [e])];
}
let S = "p";
function C(r, e) {
  let d = useId(), t = a$1(), { id: i = `headlessui-description-${d}`, ...l } = r, n$1 = f(), s = y(e);
  n(() => n$1.register(i), [i, n$1.register]);
  let o2 = t || false, p = useMemo(() => ({ ...n$1.slot, disabled: o2 }), [n$1.slot, o2]), D = { ref: s, ...n$1.props, id: i };
  return H({ ourProps: D, theirProps: l, slot: p, defaultTag: S, name: n$1.name || "Description" });
}
let _ = W(C), w = Object.assign(_, {});
export {
  w as Description,
  G as useDescribedBy,
  U as useDescriptions
};
